import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=3a98d16b&scoped=true"
import script from "./relations.vue?vue&type=script&lang=js"
export * from "./relations.vue?vue&type=script&lang=js"
import style0 from "./relations.vue?vue&type=style&index=0&id=3a98d16b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98d16b",
  null
  
)

export default component.exports